export const SET_IS_PENDING = 'rpb2b-react/checkout/SET_IS_PENDING';
export type SET_IS_PENDING = typeof SET_IS_PENDING;

export const SET_ORDER_CONFIRMED = 'rpb2b-react/checkout/SET_ORDER_CONFIRMED';
export type SET_ORDER_CONFIRMED = typeof SET_ORDER_CONFIRMED;

export const SET_ORDER_SHIPPING_METHOD =
  'rpb2b-react/checkout/SET_ORDER_SHIPPING_METHOD';
export type SET_ORDER_SHIPPING_METHOD = typeof SET_ORDER_SHIPPING_METHOD;

export const SET_CREDIT_CARD_URL = 'rpb2b-react/checkout/SET_CREDIT_CARD_URL';
export type SET_CREDIT_CARD_URL = typeof SET_CREDIT_CARD_URL;

export const SET_PENDING_ORDER_NUMBER =
  'rpb2b-react/checkout/SET_PENDING_ORDER_NUMBER';
export type SET_PENDING_ORDER_NUMBER = typeof SET_PENDING_ORDER_NUMBER;

export const SET_CONFIRMATION_NUMBER =
  'rpb2b-react/checkout/SET_CONFIRMATION_NUMBER';
export type SET_CONFIRMATION_NUMBER = typeof SET_CONFIRMATION_NUMBER;

export const SET_CHECKOUT_CODE = 'rpb2b-react/checkout/SET_CHECKOUT_CODE';
export type SET_CHECKOUT_CODE = typeof SET_CHECKOUT_CODE;

export const SET_CART = 'rpb2b-react/checkout/SET_CART';
export type SET_CART = typeof SET_CART;

export const SET_SUBTOTAL = 'rpb2b-react/checkout/SET_SUBTOTAL';
export type SET_SUBTOTAL = typeof SET_SUBTOTAL;

export const SET_TAX = 'rpb2b-react/checkout/SET_TAX';
export type SET_TAX = typeof SET_TAX;

export const SET_TOTAL = 'rpb2b-react/checkout/SET_TOTAL';
export type SET_TOTAL = typeof SET_TOTAL;

export const SET_DEFAULT_MOT = 'rpb2b-react/checkout/SET_DEFAULT_MOT';
export type SET_DEFAULT_MOT = typeof SET_DEFAULT_MOT;

export const SET_TERMS_OF_DELIVERY =
  'rpb2b-react/checkout/SET_TERMS_OF_DELIVERY';
export type SET_TERMS_OF_DELIVERY = typeof SET_TERMS_OF_DELIVERY;

export const SET_SOFT_CREDIT_HOLD = 'rpb2b-react/checkout/SET_SOFT_CREDIT_HOLD';
export type SET_SOFT_CREDIT_HOLD = typeof SET_SOFT_CREDIT_HOLD;

export const SET_ERROR = 'rpb2b-react/checkout/SET_ERROR';
export type SET_ERROR = typeof SET_ERROR;

export const PLACE_ORDER_PROGRESS = 'rpb2b-react/checkout/PLACE_ORDER_PROGRESS';
export type PLACE_ORDER_PROGRESS = typeof PLACE_ORDER_PROGRESS;

export default {
  SET_IS_PENDING,
  SET_ORDER_CONFIRMED,
  SET_CREDIT_CARD_URL,
  SET_PENDING_ORDER_NUMBER,
  SET_CONFIRMATION_NUMBER,
  SET_CHECKOUT_CODE,
  SET_CART,
  SET_SUBTOTAL,
  SET_DEFAULT_MOT,
  SET_TERMS_OF_DELIVERY,
  SET_TAX,
  SET_TOTAL,
  SET_ERROR,
  SET_SOFT_CREDIT_HOLD,
  SET_ORDER_SHIPPING_METHOD,
  PLACE_ORDER_PROGRESS
};
